import _slicedToArray from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "tui-conversation-list"
};
var _hoisted_2 = ["id"];
var _hoisted_3 = ["onClick", "onLongpress", "onContextmenu"];
var _hoisted_4 = {
  "class": "left"
};
var _hoisted_5 = {
  key: 1,
  "class": "num"
};
var _hoisted_6 = {
  key: 2,
  "class": "num-notify"
};
var _hoisted_7 = {
  "class": "content"
};
var _hoisted_8 = {
  "class": "content-header"
};
var _hoisted_9 = {
  "class": "content-header-label"
};
var _hoisted_10 = {
  "class": "name"
};
var _hoisted_11 = {
  "class": "middle-box"
};
var _hoisted_12 = {
  key: 0,
  "class": "middle-box-at"
};
var _hoisted_13 = {
  "class": "middle-box-content"
};
var _hoisted_14 = {
  "class": "content-footer"
};
var _hoisted_15 = {
  "class": "time"
};
import { ref } from "../../../adapter-vue";
import TUIChatEngine, { TUIStore, StoreName, TUIConversationService } from "@tencentcloud/chat-uikit-engine";
import Icon from "../../common/Icon.vue";
import Avatar from "../../common/Avatar/index.vue";
import ActionsMenu from "../actions-menu/index.vue";
import muteIcon from "../../../assets/icon/mute.svg";
import { isPC, isH5, isUniFrameWork } from "../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["handleSwitchConversation", "getPassingRef"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var emits = __emit;
    var _currentConversation = ref();
    var _currentConversationID = ref();
    var currentConversationDomRect = ref();
    var isShowOverlay = ref(false);
    var _conversationList = ref([]);
    var conversationListDomRef = ref();
    var actionsMenuPosition = ref({
      top: 0
    });
    var _displayOnlineStatus = ref(false); // 在线状态 默认关闭
    var userOnlineStatusMap = ref();
    var lastestOpenActionsMenuTime = null;
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: function currentConversationID(id) {
        _currentConversationID.value = id;
      },
      conversationList: function conversationList(list) {
        _conversationList.value = list;
      },
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    // 初始状态
    TUIStore.watch(StoreName.USER, {
      displayOnlineStatus: function displayOnlineStatus(status) {
        _displayOnlineStatus.value = status;
      },
      userStatusList: function userStatusList(list) {
        if (list.size !== 0) {
          userOnlineStatusMap.value = _toConsumableArray(list.entries()).reduce(function (obj, _ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];
            obj[key] = value;
            return obj;
          }, {});
        }
      }
    });
    var isShowUserOnlineStatus = function isShowUserOnlineStatus(conversation) {
      return _displayOnlineStatus.value && conversation.type === TUIChatEngine.TYPES.CONV_C2C;
    };
    var showConversationActionMenu = function showConversationActionMenu(event, conversation, index, isContextMenuEvent) {
      if (isContextMenuEvent && isUniFrameWork) {
        return;
      }
      _currentConversation.value = conversation;
      lastestOpenActionsMenuTime = Date.now();
      getActionsMenuPosition(event, index);
    };
    var closeConversationActionMenu = function closeConversationActionMenu() {
      // 防止连续触发overlay的tap事件
      if (lastestOpenActionsMenuTime && Date.now() - lastestOpenActionsMenuTime > 300) {
        _currentConversation.value = undefined;
        isShowOverlay.value = false;
      }
    };
    var getActionsMenuPosition = function getActionsMenuPosition(event, index, conversation) {
      if (isUniFrameWork) {
        if (typeof conversationListDomRef.value === 'undefined') {
          emits('getPassingRef', conversationListDomRef);
        }
        var query = uni.createSelectorQuery()["in"](conversationListDomRef.value);
        query.select("#convlistitem-".concat(index)).boundingClientRect(function (data) {
          if (data) {
            actionsMenuPosition.value = {
              // uni-h5的uni-page-head不被认为是视窗中的成员，因此手动上head的高度
              top: data.bottom + (isH5 ? 44 : 0),
              left: event.touches[0].pageX,
              conversationHeight: data.height
            };
            isShowOverlay.value = true;
          }
        }).exec();
      } else {
        var _event$currentTarget;
        // 处理Vue原生
        var rect = (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.getBoundingClientRect();
        if (rect) {
          actionsMenuPosition.value = {
            top: rect.bottom,
            left: isPC ? event.clientX : undefined,
            conversationHeight: rect.height
          };
        }
        isShowOverlay.value = true;
      }
    };
    var enterConversationChat = function enterConversationChat(conversationID) {
      emits("handleSwitchConversation", conversationID);
      TUIConversationService.switchConversation(conversationID);
    };
    // 暴露给父组件，当监听到滑动事件时关闭actionsMenu
    __expose({
      closeChildren: closeConversationActionMenu
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isShowOverlay) ? (_openBlock(), _createBlock(ActionsMenu, {
        key: 0,
        selectedConversation: _unref(_currentConversation),
        actionsMenuPosition: _unref(actionsMenuPosition),
        selectedConversationDomRect: _unref(currentConversationDomRect),
        onCloseConversationActionMenu: closeConversationActionMenu
      }, null, 8, ["selectedConversation", "actionsMenuPosition", "selectedConversationDomRect"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_conversationList), function (conversation, index) {
        return _openBlock(), _createElementBlock("div", {
          id: "convlistitem-".concat(index),
          key: index,
          "class": _normalizeClass(['TUI-conversation-content', !_unref(isPC) && 'TUI-conversation-content-h5'])
        }, [_createElementVNode("div", {
          onClick: function onClick($event) {
            return enterConversationChat(conversation.conversationID);
          },
          onLongpress: function onLongpress($event) {
            return showConversationActionMenu($event, conversation, index);
          },
          onContextmenu: _withModifiers(function ($event) {
            return showConversationActionMenu($event, conversation, index, true);
          }, ["prevent"]),
          "class": _normalizeClass([_unref(isPC) && 'isPC', 'TUI-conversation-item', _unref(_currentConversationID) === conversation.conversationID && 'TUI-conversation-item-selected', conversation.isPinned && 'TUI-conversation-item-pinned'])
        }, [_createElementVNode("aside", _hoisted_4, [_createVNode(Avatar, {
          useSkeletonAnimation: "",
          url: conversation.getAvatar(),
          size: "30px"
        }, null, 8, ["url"]), _unref(userOnlineStatusMap) && isShowUserOnlineStatus(conversation) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "class": _normalizeClass(['online-status', Object.keys(_unref(userOnlineStatusMap)).length > 0 && Object.keys(_unref(userOnlineStatusMap)).includes(conversation.userProfile.userID) && _unref(userOnlineStatusMap)[conversation.userProfile.userID].statusType === 1 ? 'online-status-online' : 'online-status-offline'])
        }, null, 2)) : _createCommentVNode("", true), conversation.unreadCount > 0 && !conversation.isMuted ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(conversation.unreadCount > 99 ? "99+" : conversation.unreadCount), 1)) : _createCommentVNode("", true), conversation.unreadCount > 0 && conversation.isMuted ? (_openBlock(), _createElementBlock("span", _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("label", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(conversation.getShowName()), 1)]), _createElementVNode("div", _hoisted_11, [conversation.type === 'GROUP' && conversation.groupAtInfoList && conversation.groupAtInfoList.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(conversation.getGroupAtInfo()), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_13, _toDisplayString(conversation.getLastMessage("text")), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(conversation.getLastMessage("time")), 1), conversation.isMuted ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(muteIcon)
        }, null, 8, ["file"])) : _createCommentVNode("", true)])])], 42, _hoisted_3)], 10, _hoisted_2);
      }), 128))]);
    };
  }
});